import accomodationApi from './api';

export * from './api';
export default accomodationApi;
